import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

export function startRaster(deviceID, body = {}, retry = true) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  const url = apiConfig.cmServiceDevicesRaster(deviceID);

  return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) })
    .then((response) => {
      if (response.status === 202) {
        return response.json();
      } else {
        return response.text().then((x) => {
          throw new Error(x);
        });
      }
    })
    .catch((e) => {
      console.log('raster error = ' + e.message);
      switch (e.message) {
        case '420':
          const auth = window.__APP_AUTH;
          if (auth && retry) {
            return auth.renewSession().then(() => {
              return startRaster(deviceID, body, (retry = false));
            });
          } else {
            handle420();
          }
          break;
        default:
          throw e;
      }
    });
}

export function checkRaster({ url }) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  return fetch(url, { headers: headers, method: 'GET' })
    .then((res) => res.json())
    .catch((error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log(error);
      }
    });
}
